import { Capacitor, registerPlugin } from "@capacitor/core";
import { AndroidActions } from "./androidActions";

const AppSettings = registerPlugin<{ openSettings(): Promise<void> }>("AppSettings");

export async function openAppSettings(): Promise<void> {
  if (Capacitor.getPlatform() === "ios") return AppSettings.openSettings();
  if (Capacitor.getPlatform() === "android") return AndroidActions.openSettings();
  throw new Error("App settings are available in the mobile app.");
}
